import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {Button} from '@vio/atlas/Button'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {ANIMATION_TYPES, Overlay} from '@vio/atlas/Overlay'

import {getIsRtlLanguage} from '@daedalus/core/src/auth/modules/selectors'

const CloseButton = styled(Button)`
  opacity: 0.6;
`

const DESKTOP_OVERLAY_WIDTH = 480

interface Props {
  isOpen: boolean
  children: React.ReactNode
  hasCloseButton?: boolean
  onClose?: () => void
}

export const FreezeOverlay: React.FC<Props> = ({
  isOpen,
  children,
  hasCloseButton,
  onClose
}) => {
  const {isMobile} = useDeviceLayout()
  const isRtlLanguage = useSelector(getIsRtlLanguage)

  if (isMobile)
    return (
      <Overlay isOpen={isOpen} animationType={ANIMATION_TYPES.SLIDE_DOWN}>
        {children}
      </Overlay>
    )

  return (
    <Overlay
      animatePresenceInitial
      enableBodyScrollLock
      transitionDuration={300}
      isOpen={isOpen}
      onShadeBackgroundClick={onClose}
      containerStyles={{
        width: DESKTOP_OVERLAY_WIDTH,
        marginLeft: `calc(100vw - ${DESKTOP_OVERLAY_WIDTH}px)`
      }}
      animationType={
        isRtlLanguage ? ANIMATION_TYPES.SLIDE_LEFT : ANIMATION_TYPES.SLIDE_RIGHT
      }
      onClose={onClose}
      closeOnEsc={true}
    >
      {hasCloseButton && (
        <>
          <Box
            display="flex"
            flexDirection="row-reverse"
            paddingTop="s300"
            paddingBottom="s300"
            paddingRight="s200"
            paddingLeft="s200"
          >
            <CloseButton onClick={onClose} variant="quiet">
              <Icon name="Close" colorPath="content.neutral.c950" />
            </CloseButton>
          </Box>
          <Divider />
        </>
      )}

      {children}
    </Overlay>
  )
}
